export default {
  actionIcon: "StarIcon",
  highlightColor: "warning",
  data: [
    {
      index: 0,
      label: "Contratos",
      url: "/contratos",
      labelIcon: "FileIcon",
      highlightAction: false
    },
    {
      index: 1,
      label: "Page 2",
      url: "/page2",
      labelIcon: "CalendarIcon",
      highlightAction: false
    },
    {
      index: 2,
      label: "Estado Select",
      url: "/estado-select",
      labelIcon: "CalendarIcon",
      highlightAction: false
    }
  ]
};
